import React from 'react'

const printSettingsPageRoutes = [
    {
        path: '/PrintSettingsPage',
        component: React.lazy(() => import('./PrintSettingsPage')),
        auth:'SA',
        accessPageName: 'PRINTSETTINGSPAGE'
    }
]

export default printSettingsPageRoutes